import React from 'react';
import Hero, { HeroProps } from './Hero';
import SuccessHeaderSvg from './SuccessHeaderSvg';

export const SuccessHeader: React.FunctionComponent<HeroProps> = (props) => {
    return (
        <Hero {...props}>
            <SuccessHeaderSvg />
        </Hero>
    );
};

SuccessHeader.displayName = 'SuccessHeader';

export const SuccessHeaderSpot: React.FunctionComponent<HeroProps> = (props) => {
    return (
        <Hero {...props} sx={{ display: 'flex', ...props.sx }}>
            <SuccessHeaderSvg variant="spot" />
        </Hero>
    );
};

SuccessHeaderSpot.displayName = 'SuccessHeaderSpot';
